/**
 * SIGFU REST DATA API
 * Serveur d\'api en NodeJs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DepotLigneAddress } from './depotLigneAddress';


export interface DepotLigneParty { 
    id: string;
    dtype: string;
    currentid: string;
    uid: string;
    versionrev: number;
    version_life: number;
    action: string;
    begin_life: string;
    end_life: string;
    ext_json: object;
    original: string;
    protection_owner: string;
    birth_date: string;
    deceased: boolean;
    description: string;
    email: string;
    fax: string;
    first_name: string;
    full_name: string;
    id_number: string;
    incapacitated: boolean;
    last_name: string;
    middle_name: string;
    minor: boolean;
    national_id: string;
    phone1_extension: string;
    phone1_number: string;
    phone2_extension: string;
    phone2_number: string;
    prid: string;
    tax_number: string;
    title_holder: boolean;
    birth_place: string;
    create_datetime: string;
    death_date: string;
    father_name: string;
    field_of_work: string;
    representative_first_name: string;
    headquaters: string;
    id_document_date: string;
    id_doc_issued_by: string;
    representative_last_name: string;
    logo: string;
    married_name: string;
    mother_name: string;
    person_count: number;
    profession: string;
    registration_number: string;
    trade_registrar: string;
    object_origin: string;
    status_original: string;
    protection: string;
    status: string;
    transaction_id: string;
    address: DepotLigneAddress;
    citizenship: string;
    gender_type: string;
    id_type: string;
    salutation_type: string;
    phone1_type: string;
    phone2_type: string;
    party_type: string;
    group_type: string;
    country_origin: string;
    marital_status_type: string;
}

